import CustomMultiSelect from "vagaro-website-rendering/src/components/CustomMultiSelect";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetLinearPageOptions } from "../Menus/PageSelectMenu";
import { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

export default function MultiPageSelect({label,definition,layoutObject,updateFunc,screenSize,saveFunc,siteData}:AttributeFieldProps){






    const pages = GetLinearPageOptions(siteData);
    let val = getNodeComponentAttributeValue(layoutObject,definition.attribute,'');
    let selected = val.split(",");


    return (
      <div className="wb-input-group no-border" style={{padding:"0px"}}>
       
            <CustomMultiSelect 
                startOpen={false}
                useDualHeader={true}
                placeholder="Select pages"
                options={pages}
                onChange={(selected) => updateFunc(definition.attribute, selected.join(","), definition.targetType)}
                defaultValues={selected} footer={undefined}  />
      </div>
    );

}